import { useDictionary, useLocation } from "gemi/client";
import { TERMS_SEEN_COOKIE, TERMS_VERSION } from "@/app/utils/legal";
import { termsNoticeDict } from "./TermsNotice.i18n";

/** The passive Terms of Use notice every web sign-up screen shows. */
export function TermsNotice({ className }: { className?: string }) {
  const t = useDictionary(termsNoticeDict);
  const { locale } = useLocation();
  // Plain anchors: gemi's <Link> always navigates in place, which would drop the sign-up form.
  const prefix = locale ? `/${locale}` : "";
  const linkClass = "underline underline-offset-2 hover:text-foreground";

  return (
    <p className={className}>
      {t.jsx("notice", {
        terms: (text) => (
          <a
            href={`${prefix}/terms-and-conditions`}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClass}
          >
            {text}
          </a>
        ),
        privacy: (text) => (
          <a
            href={`${prefix}/privacy-policy`}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClass}
          >
            {text}
          </a>
        ),
      })}
    </p>
  );
}

/**
 * Called by a Google button beside the notice. gemi's OAuth round trip keeps no query param, so the
 * cookie is what tells `onSignUp` that a new Google account saw the notice.
 */
export function rememberTermsNoticeSeen() {
  const secure = window.location.protocol === "https:" ? "; secure" : "";
  document.cookie = `${TERMS_SEEN_COOKIE}=${TERMS_VERSION}; path=/; max-age=600; samesite=lax${secure}`;
}
